module.exports = __webpack_public_path__ + "img/clock-rotate-left.2c157a64.svg";